import httpClient from '@/http-client'

export const store = data => {
  return httpClient
    .post('/api/v1/tax-rangs', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const taxRangeMain = (Option = {}) => {
  return httpClient
    .get('/api/v1/tax-rangs/tax-range-mains', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const get = (options = {}) => {
  return httpClient
    .get('/api/v1/tax-rangs', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { store, taxRangeMain, get }
